import type { Environment, PageType } from '@shared/types/utils';

// The Houston URL is a special /500.ashx endpoint for tracking a client side crash
// https://tower.skyscannertools.net/systems/component/pokemon/overview
export const getHoustonUrl = ({
  environment,
  pageType,
}: {
  environment: Environment;
  pageType: PageType;
}) =>
  environment === 'production'
    ? `/500.ashx?source=hotels&prevPageGroup=${pageType}`
    : null;
